/*
Flexible Materials
  --bend <float> | inches | ('Inches of Bend')
  --coreType <string::combobox>
  --insideRadius <float> | inches
  --outsideRadius <float> | inches
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Flexible Materials'
const id = 'bwWo1HsQlT9gw6g5pL2T'

export default {
  name,
  id,
  filters,
  headers,
  form
}
